import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getDailyPerformancePreviousDate } from "../../lib/utils/dailyPerformanceReport"

/**
 * Old GET …/report/page/clients/{id}/daily/performance is retired. Do not call it.
 * Soho Pulse Engagement / Followers use the page social-performance report instead.
 */
export const fetchDailyPerformance = createAsyncThunk(
  "dailyPerformance/fetch",
  async ({ clientId, previousDate } = {}, { rejectWithValue }) => {
    if (clientId == null || clientId === "") {
      return rejectWithValue("clientId is required")
    }
    const prev = previousDate || getDailyPerformancePreviousDate()
    return {
      rows: [],
      clientId: String(clientId),
      previousDate: prev,
    }
  },
  {
    condition: () => false,
  },
)

const initialState = {
  rows: [],
  status: "idle",
  error: null,
  requestedClientId: null,
  fetchedClientId: null,
  previousDate: null,
}

const dailyPerformanceSlice = createSlice({
  name: "dailyPerformance",
  initialState,
  reducers: {
    clearDailyPerformance: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyPerformance.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.rows = action.payload?.rows ?? []
        state.fetchedClientId = action.payload?.clientId ?? null
        state.previousDate = action.payload?.previousDate ?? null
      })
      .addCase(fetchDailyPerformance.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch daily performance"
        state.rows = []
      })
  },
})

export const { clearDailyPerformance } = dailyPerformanceSlice.actions
export default dailyPerformanceSlice.reducer
